import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-qr-card',
  templateUrl: './qr-card.component.html',
  styleUrls: ['./qr-card.component.scss']
})
export class QrCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
